import './main.css';
import { faTractor, faDog, faPills, faVial, faFlaskVial, faTooth, faStethoscope} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Main() {
    return (
        <div className="main">
            <img src={"../logos/chemistry_table.png"} alt="chemistry-table" className="chemistry-table" />
            <img src={"../logos/molecule.png"} alt="molecule" className="molecule" />
            <h1 id="main-info" className="main-title">ČASOVI HEMIJE</h1>
            <ul className="main-info-list">
                <li>PRIPREMA ZA PRIJEMNE ISPITE
                    <ul className="school-list">    
                        <li>
                            <span><FontAwesomeIcon icon={faStethoscope} /></span>
                            MEDICINSKI FAKULTET
                        </li>
                        <li>
                            <span><FontAwesomeIcon icon={faTooth} /></span>
                            STOMATOLOŠKI FAKULTET
                        </li>
                        <li>
                            <span><FontAwesomeIcon icon={faFlaskVial} /></span>
                            TEHNOLOŠKO-METALURŠKI FAKULTET
                        </li>
                        <li>
                            <span><FontAwesomeIcon icon={faDog} /></span>
                            VETERINARSKI FAKULTET
                        </li>
                        <li>
                            <span><FontAwesomeIcon icon={faPills} /></span>
                            FARMACEUTSKI FAKULTET
                        </li>
                        <li>
                            <span><FontAwesomeIcon icon={faVial} /></span>
                            HEMIJSKI FAKULTET
                        </li>
                        <li>
                            <span><FontAwesomeIcon icon={faTractor} /></span>
                            POLJOPRIVREDNI FAKULTET
                        </li>
                    </ul>
                </li>
                <li>PRIPREME KREĆU OD OKTOBRA</li>
                <li>NIJE POTREBNO NIKAKVO PREDZNANJE</li>
                <li>NAKON SVAKOG ČASA DOBIJA SE MATERIJAL U KOME JE SAŽETO SVO PREĐENO GRADIVO POTREBNO ZA PRIPREMU PRIJEMNOG ISPITA,
                    KAO I URAĐENI SVI TIPOVI ZADATAKA
                </li>
            </ul>
        </div>
    );
}